import React from 'react'
import Validator from "dataphi-react-components/dist/Containers/FormScreen/FormComponent/Validator";
import moment from 'moment'

var maxValue = function maxValue(max) {
    return function(value) {
        return !!!value ? undefined : value > max ? "Must be less than " + max : undefined;
    };
};

var minValue = function minValue(min) {
    return function(value) {
        return !!!value ? undefined : value < min ? "Must be greater than " + min : undefined;
    };
};

var timeOut = function timeOut(type) {
    return function(value) {
        let flag;
        let timeIn = Boolean(document.getElementById('med_in_time').value);
        if(Boolean(value) && Boolean(document.getElementById('med_in_time').value)){
            flag = value.toString() >= (document.getElementById('med_in_time').value).toString()
            return flag ? undefined :  "Must be greater than Time in " ;

        }
        else {
            return undefined;
        }
    };
};

var checkCurrentTime = function checkCurrentTime() {
   return function(value) {
    let flag;
    if(Boolean(value)){
        flag = value.toString() <= moment().format('HH:mm').toString();
        return flag ? undefined :  "Cannot be greater than current Time " ;

    }
   } 
}

var bodyTempValidation = function bodyTempValidation() {
    return function(value) {
        let selectedOption = document.getElementById('body_temperature_select').value;
        const max_for_c = 43, min_for_c = 32, max_for_f = 110, min_for_f = 90;

        if(selectedOption === 'c'){
            if(value > max_for_c) {
                return !!!value ? undefined : value > min_for_c && value < max_for_c  ?  undefined  : `Must be less then ${max_for_c }`;
            }
            if(value < min_for_c){
                return !!!value ? undefined : value > min_for_c && value < max_for_c  ?  undefined  : `Must be greater than ${min_for_c }`;
            }
        }
        else {
            if(value > max_for_f) {
                return !!!value ? undefined : value > min_for_f && value < max_for_f  ?  undefined  : `Must be less then ${max_for_f}`;
            }
            if(value < min_for_f){
                return !!!value ? undefined : value > min_for_f && value < max_for_f  ?  undefined  : `Must be greater than ${min_for_f }`;
            }
        }
    };
};

const formDefButtons = {
    closeButton: {
        text: "Cancel",
        className: {
            fieldClassName: "btn hsg-btn-primary col-md-2 col-sm-2 col-xs-2 right",
            groupClassName: "right col-md-12 col-sm-12 col-xs-12"
        }
    },
    submitButton: {
        text: "Save",
        className: {
            fieldClassName: "btn hsg-btn-primary col-md-2 col-sm-2 col-xs-2 right",
            groupClassName: "right col-md-12 col-sm-12 col-xs-12"
        }
    }
};


const AddHeader = (subScreenName) => (
    <div className="col-md-12 col-sm-12 col-xs-12" style={{padding: 5}}>
        <div className="">
                {subScreenName}
        </div>
    </div>
)

const formDefAnthropometric = [
    {
        name: 'anthropometric',
        type: 'wildcard',
        component: AddHeader('ANTHROPOMETRIC')
    },
    {
        name: "med_height",
        type: "number",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Height",
        placeholder: "cm",
        validation: [Validator.required, maxValue(250), minValue(20)]
    },
    {
        name: "med_weight",
        type: "number",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Weight",
        placeholder: "kg",
        validation: [Validator.required, maxValue(150), minValue(5)]
    },
    {
        name: "med_in_time",
        type:'time',
        className: {
           fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Time In",
        placeholder: "hh:mm",
        validation: [checkCurrentTime()],
    },
    {
        name: "med_out_time",
        type:'time',
        className: {
          fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Time Out",
        placeholder: "hh:mm",
        validation: [timeOut(),checkCurrentTime()],
        disabled: true
    },
];

const formDefVitals = [
    {
        name: 'vitals',
        type: 'wildcard',
        component: AddHeader('VITALS')
    },
    {
        name: "med_bp_sys",
        type: "number",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "BP Sys.",
        placeholder: "mmHg",
        validation: [minValue(0)]
    },
    {
        name: "med_bp_dia",
        type: "number",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "BP Dia.",
        placeholder: "mmHg",
        validation: [minValue(0)]
    },
    {
        name: "med_heart_rate",
        type: "number",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Heart Rate",
        placeholder: "beats per minute",
        validation: [minValue(0)]
    },
    {
        name: "med_body_temp",
        type: "number",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Body Temperature",
        placeholder: "°c",
        validation: [ bodyTempValidation(), minValue(0)]
    },
    {
        name: "med_respiratory_rate",
        type: "number",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Respiratory Rate",
        placeholder: "breaths per minute",
        validation: [minValue(0)]
    },
    {
        name: "med_spo2",
        type: "number",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "SpO2",
        placeholder: "SpO2",
        validation: [maxValue(100),minValue(0)]
    },
    {
        name: "med_in_time",
        type:'time',
        className: {
           fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Time In",
        placeholder: "hh:mm",
        validation: [checkCurrentTime()],
    },
    {
        name: "med_out_time",
        type:'time',
        className: {
          fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Time Out",
        placeholder: "hh:mm",
        validation: [timeOut(),checkCurrentTime()],
        disabled:true
    },
];

const formDefEpisode = [
    {
        name: 'episode',
        type: 'wildcard',
        component: AddHeader('EPISODE')
    },
    {
        name: "med_complaint",
        type: "textarea",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Complaints",
        placeholder: "",
        validation: [Validator.required]
    },
    {
        name: "med_symptoms",
        type: "textarea",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Sign/Symptom",
        placeholder: "",
        validation: []
    },
    {
        name: "med_suggestion",
        type: "textarea",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Treatment/Suggestions",
        placeholder: "",
        validation: [Validator.required]
    },
    {
        name: "med_remark",
        type: "textarea",
        className: {
            fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Remark",
        placeholder: "",
        validation: []
    },
    {
        name: "med_in_time",
        type:'time',
        className: {
           fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Time In",
        placeholder: "hh:mm",
        validation: [checkCurrentTime()],
    },
    {
        name: "med_out_time",
        type:'time',
        className: {
          fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Time Out",
        placeholder: "hh:mm",
        validation: [timeOut(),checkCurrentTime()],
        disabled:true
    },
    // {
    //     name: "med_called",
    //     type: "checkbox",
    //     className: {
    //         fieldClassName: "hsg-checkbox",
    //         groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
    //         errorClassName: "hsg-error",
    //         labelClassName: "hsg-checkbox-label"
    //     },
    //     label: "Called?",
    //     placeholder: "",
    //     options: [
    //         {
    //             label: "Ambulance",
    //             value: "ambulance"
    //         },
    //         {
    //             label: "Parent",
    //             value: "parent"
    //         }
    //     ],
    //     validation: []
    // },
    {
        name: "loadMoreComponents",
        type: "loadMoreComponents"
    }
];

const eyeOptions = [
    {
        label: "6/6",
        value: "6/6",
        className: "hsg-select-options"
    },
    {
        label: "6/9",
        value: "6/9",
        className: "hsg-select-options"
    },
    {
        label: "6/12",
        value: "6/12",
        className: "hsg-select-options"
    },
    {
        label: "6/24",
        value: "6/24",
        className: "hsg-select-options"
    },
    {
        label: "6/36",
        value: "6/36",
        className: "hsg-select-options"
    },
    {
        label: "6/60",
        value: "6/60",
        className: "hsg-select-options"
    }
];

const formDefEye = [
    {
        name: 'optometry',
        type: 'wildcard',
        component: AddHeader('OPTOMETRY')
    },
    {
        name: "optometryLeft",
        type: "select",
        className: {
            fieldClassName: "hsg-input-select",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Left (Without Spectacles)",
        placeholder: "",
        options: eyeOptions,
        validation: [Validator.required]
    },
    {
        name: "optometryRight",
        type: "select",
        className: {
            fieldClassName: "hsg-input-select",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Right (Without Spectacles)",
        placeholder: "",
        options: eyeOptions,
        validation: [Validator.required]
    },
    {
        name: "optometryLeftSpectacles",
        type: "select",
        className: {
            fieldClassName: "hsg-input-select",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Left (With Spectacles)",
        placeholder: "",
        options: eyeOptions,
        validation: []
    },
    {
        name: "optometryRightSpectacles",
        type: "select",
        className: {
            fieldClassName: "hsg-input-select",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Right (With Spectacles)",
        placeholder: "",
        options: eyeOptions,
        validation: []
    },
    {
        name: "med_in_time",
        type:'time',
        className: {
           fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Time In",
        placeholder: "hh:mm",
        validation: [checkCurrentTime()],
    },
    {
        name: "med_out_time",
        type:'time',
        className: {
          fieldClassName: "hsg-input",
            groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
            errorClassName: "hsg-error",
            labelClassName: "hsg-input-label"
        },
        label: "Time Out",
        placeholder: "hh:mm",
        validation: [timeOut(),checkCurrentTime()],
        disabled:true
    },
];

const formDefs = {
    closeButton: {
        text: "Cancel",
        className: {
            fieldClassName: "btn hsg-btn-primary col-md-2 col-sm-2 col-xs-2 right",
            groupClassName: "col-md-12 col-sm-12 col-xs-12"
        }
    },
    submitButton: {
        text: "Save",
        className: {
            fieldClassName: "btn hsg-btn-primary col-md-2 col-sm-2 col-xs-2 right",
            groupClassName: "col-md-12 col-sm-12 col-xs-12"
        }
    },
    metaData: [
        {
            name: "med_height",
            type: "number",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "Height",
            placeholder: "cm",
            validation: [maxValue(250), minValue(20)]
        },
        {
            name: "med_weight",
            type: "number",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-6 col-sm-6 col-xs-6",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "Weight",
            placeholder: "kg",
            validation: [maxValue(150), minValue(5)]
        },
        {
            name: "med_bp_sys",
            type: "number",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "BP Sys.",
            placeholder: "mg/mm",
            validation: [minValue(0)]
        },
        {
            name: "med_bp_dia",
            type: "number",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "BP Dia.",
            placeholder: "mg/mm",
            validation: [minValue(0)]
        },
        {
            name: "med_heart_rate",
            type: "number",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "Heart Rate",
            placeholder: "per minute",
            validation: [minValue(0)]
        },
        {
            name: "med_body_temp",
            type: "number",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "Body Temprature",
            placeholder: "°c",
            validation: [bodyTempValidation(), minValue(0)]
        },
        {
            name: "med_respiratory_rate",
            type: "number",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-4 col-sm-4 col-xs-4",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "Respiratory Rate",
            placeholder: "per minute",
            validation: [minValue(0)]
        },
        {
            name: "med_complaint",
            type: "text",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "Complaints",
            placeholder: "",
            validation: [Validator.required]
        },
        {
            name: "med_symptoms",
            type: "text",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "Symptoms",
            placeholder: "",
            validation: [Validator.required]
        },
        {
            name: "med_suggestion",
            type: "text",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "Suggesions",
            placeholder: "",
            validation: [Validator.required]
        },
        {
            name: "med_remark",
            type: "text",
            className: {
                fieldClassName: "hsg-input",
                groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
                errorClassName: "hsg-error",
                labelClassName: "hsg-input-label"
            },
            label: "Remark",
            placeholder: "",
            validation: []
        },
        {
            name: "med_called",
            type: "checkbox",
            className: {
                fieldClassName: "hsg-checkbox",
                groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
                errorClassName: "hsg-error",
                labelClassName: "hsg-checkbox-label"
            },
            label: "Called?",
            placeholder: "",
            options: [
                {
                    label: "Ambulance",
                    value: "ambulance"
                },
                {
                    label: "Parent",
                    value: "parent"
                }
            ],
            validation: []
        }
    ]
};

export default {
    formDefs,
    minValue,
    maxValue,

    formDefAnthropometric,
    formDefEpisode,
    formDefEye,
    formDefVitals,

    formDefButtons
};



// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainerV2/Component/Episode/Source.js